import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { cmsApiRequest } from "../../Lib/Utils/ApiRequest";
import { getLocaleFromCookie } from "../../Lib/Utils/getLocaleFromCookie";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { ICmsUsefulInformationResponse } from "../../Orchestrator/Types/Interface/ICmsUsefulInformaton";

export async function getCmsUsefulInfoDetailBySlug(
  slug: string
): Promise<IApiResponse<ICmsUsefulInformationResponse>> {
  const ENDPOINTS = await getEndpoints();
  const endpoint = ENDPOINTS.getUsefulInformationAPI;
  const params = new URLSearchParams();
  params.append("filters[slug][$eq]", slug);
  params.append("populate[help_icon][populate]", "*");
  params.append("locale", await getLocaleFromCookie());

  let endpointWithParams = `${endpoint}?${params.toString()}`;
  return await cmsApiRequest<ICmsUsefulInformationResponse>(
    endpointWithParams,
    "GET"
  );
}
